import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import CompanyDataForm from './Form';
import TopActions from './TopActions';

const Component = ({ theme, Styled, topAction, i18n, updateCard, updateCardDetails, callback, history, ...rest }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Styled.Wrapper>
        {topAction && <TopActions {...{ i18n, updateCard, callback, updateCardDetails, history, Styled, ...rest }} />}
        <CompanyDataForm {...rest} Styled={Styled} i18n={i18n} updateCard={updateCard} callback={callback} history={history} />
      </Styled.Wrapper>
    </Box>
  );
};

export default Component;

Component.propTypes = {
  Styled: PropTypes.object.isRequired,
};
